/**
 * Collapses a template title into a short equipment-type label for grouping PMS
 * lists (e.g. "HT Panel PMS (Every 15 Days)" -> "HT Panel", "Transformer PMS
 * (Every 15 Days)" -> "Transformer"). Mirrors apps-script/Schedule.gs#pmsGroupLabel_
 * — keep the two in sync.
 */
export function pmsGroupLabel(title: string): string {
  const s = title.replace(/\s*\(.*?\)\s*$/, '').replace(/\s*PMS\s*$/i, '').trim();
  return s || title;
}

/** A template (or its equipment) is PMS-flavoured if the title says so — same signal pmsGroupLabel strips. */
export function isPmsTitle(title: string): boolean {
  return /\bPMS\b/i.test(title);
}

/** Groups items by a derived label, preserving each group's first-seen order. */
export function groupBy<T>(items: T[], labelOf: (item: T) => string): Array<{ label: string; items: T[] }> {
  const order: string[] = [];
  const byLabel = new Map<string, T[]>();
  items.forEach((item) => {
    const label = labelOf(item);
    if (!byLabel.has(label)) { byLabel.set(label, []); order.push(label); }
    byLabel.get(label)!.push(item);
  });
  return order.map((label) => ({ label, items: byLabel.get(label)! }));
}
